// extracted by mini-css-extract-plugin
module.exports = {"successful_payment":"FailedPaymentCard_successful_payment__1Vp9s"};